import { useMemo } from 'react';
import type { ReactNode } from 'react';

import loadable from '@loadable/component';

import type { Watchlist, WatchlistItem } from '@/hooks/useWatchlist';

import { useFairValueModals } from '../hooks/useFairValueModals';
import { useWatchlistAddFairValue } from '../hooks/useWatchlistAddFairValue';

import { FairValueProvider } from './fairValueContext';

const FairValueModal = loadable(() => import('../components/FairValueModal'), {
  resolveComponent: (c) => c.FairValueModal,
});

type Props = {
  children: ReactNode;
  watchlistId: Watchlist['id'];
  watchlistItem: WatchlistItem;
};

export const WatchlistFairValueProvider = ({
  watchlistItem,
  watchlistId,
  children,
}: Props) => {
  const { state, actions } = useFairValueModals();
  const mutation = useWatchlistAddFairValue({
    watchlistId,
    companyId: watchlistItem.company.id,
    onSuccess() {
      actions.toggleFairValueModal();
    },
  });
  const value = useMemo(
    () => ({
      state,
      actions,
      mutation,
    }),
    [state, actions, mutation]
  );

  return (
    <FairValueProvider value={value}>
      {children}
      {state.isFairValueModalOpen ? (
        <FairValueModal
          company={watchlistItem.company}
          defaultFairValue={watchlistItem.fairValue}
        />
      ) : null}
    </FairValueProvider>
  );
};
